import * as React from 'react';
import ScrollableArea from 'components/ScrollableArea';

import './styles/StreamScrollableArea.scss';

type Props = {
  children: React.ReactNode;
  onScrollToBottom?: () => void;
};

class StreamScrollableArea extends React.Component<Props, {}> {
  // @ts-expect-error ts-migrate(2564) FIXME: Property 'ScrollableArea' has no initializer and i... Remove this comment to see the full error message
  ScrollableArea: ScrollableArea;

  scrollToBottom() {
    if (this.ScrollableArea) {
      // this is sometimes being called in ChatStreamContainer and
      // AnnouncementStreamContainer before ScrollableArea has rendered
      this.ScrollableArea.scrollToBottom();
    }
  }

  render() {
    return (
      <div className="StreamScrollableArea">
        <ScrollableArea
          onScrollToBottom={this.props.onScrollToBottom}
          ref={(a: any) => (this.ScrollableArea = a)}
          useBodyChildrenHeight
          scrollToBottom
        >
          {this.props.children}
        </ScrollableArea>
      </div>
    );
  }
}

export default StreamScrollableArea;
